import {Location} from 'react-router';

export function updateSearch(location: Location, updated: Record<string, string | null | undefined>) {
    return {
        ...location,
        search: updateSearchString(location.search, updated),
    };
}

export function updateSearchString(currentSearch: string, updated: Record<string, string | null | undefined>) {
    const search = new URLSearchParams(currentSearch);
    const current = Object.fromEntries(search.entries());
    const merged = {...current, ...updated};
    for (const [key, value] of Object.entries(merged)) {
        if (value == null) {
            search.delete(key);
        } else {
            search.set(key, value);
        }
    }
    return search.toString();
}
